import React, { useState, useEffect } from 'react'

import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'

import { Imprint } from '../pages/Imprint'
import { Privacy } from '../pages/Privacy'

import { Button } from './buttons/Button'
import { Link } from './Link'

export const CookieConsent: React.FC = () => {
    const [showConsent, setShowConsent] = useState(!Cookies.get('cookie_consent'))
    const [showImprint, setShowImprint] = useState(false)
    const [showPrivacy, setShowPrivacy] = useState(false)

    const { t } = useTranslation()

    useEffect(() => {
        if (showConsent) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }

        return () => {
            document.body.style.overflow = 'unset'
        }
    }, [showConsent])

    const acceptCookies = () => {
        Cookies.set('cookie_consent', 'true', { expires: 30 })
        setShowConsent(false)
    }

    const declineCookies = () => {
        Cookies.set('cookie_consent', 'false', { expires: 30 })
        setShowConsent(false)
    }

    if (!showConsent) return null

    const toggleImprint = () => {
        setShowImprint(!showImprint)
    }

    const togglePrivacy = () => {
        setShowPrivacy(!showPrivacy)
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-primary-blue bg-opacity-35 z-50">
            <div
                className={`flex justify-center bg-primary-green bg-opacity-100 text-white p-5 rounded-lg max-w-2xl w-1/3 max-h-[50vh] min-h-[500px] mx-4 overflow-y-auto
                sm:w-2/3 xs:w-full sm:mx-auto sm:my-auto
                ${showImprint || showPrivacy ? 'items-start' : 'items-center'}
            `}>
                {!showImprint && !showPrivacy && (
                    <div
                        className="flex flex-col items-center space-y-4
                           sm:flex-col sm:justify-center sm:items-center sm:mx-auto sm:my-auto
                    ">
                        <p className="text-center space-y-2">
                            <p className="text-3xl pb-5">{t('cookie.title')}</p>
                            <div>
                                {t('cookie.description')}
                                <Link className="underline" onClick={togglePrivacy}>
                                    {t('cookie.privacyLink')}
                                </Link>
                            </div>
                            <div>{t('cookie.acceptMessage')}</div>
                            <div>{t('cookie.declineMessage')}</div>
                        </p>
                        <div className="flex space-x-4 mx-auto">
                            <Button
                                className="hover:bg-secondary-green w-[120px] text-white font-bold py-2 px-4 rounded border"
                                onClick={acceptCookies}
                                text={t('cookie.accept')}
                            />
                            <Button
                                className="hover:bg-secondary-green w-[120px] text-white font-bold py-2 px-4 rounded border"
                                onClick={declineCookies}
                                text={t('cookie.decline')}
                            />
                        </div>
                        {!showImprint && (
                            <Link className="font-bold underline" onClick={toggleImprint}>
                                {t('imprint.title')}
                            </Link>
                        )}
                    </div>
                )}
                {showImprint && (
                    <div className="flex flex-col justify-center">
                        <Imprint textColor="text-white" />
                        <Button
                            onClick={toggleImprint}
                            className="bg-white text-primary-green px-4 py-2 rounded border"
                            text={t('common.close')}
                        />
                    </div>
                )}
                {showPrivacy && (
                    <div className="flex flex-col justify-center">
                        <Privacy textColor="text-white" />
                        <Button
                            onClick={togglePrivacy}
                            className="bg-white text-primary-green px-4 py-2 rounded border"
                            text={t('common.close')}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}
